var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-contact",
      class:
        "c-contact--" +
        _vm.variant +
        " c-contact--" +
        _vm.method +
        " " +
        (_vm.variant === "footer" ? "s-light" : "")
    },
    [
      _c(
        "div",
        { staticClass: "c-contact__icon" },
        [_c("v-icon", { attrs: { name: _vm.iconName, size: "s" } })],
        1
      ),
      _vm._v(" "),
      _vm.variant === "page"
        ? [
            _c("div", { staticClass: "c-contact__wrapper" }, [
              _c("div", { staticClass: "c-contact__heading-and-text" }, [
                _c("p", { staticClass: "c-contact__heading" }, [
                  _vm._v(_vm._s(_vm.heading))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "c-contact__text" }, [
                  _vm._v(_vm._s(_vm.text))
                ])
              ]),
              _vm._v(" "),
              _vm.method === "chat"
                ? _c("p", { staticClass: "c-contact__link" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "c-button c-button--noboxshadow c-button--icon",
                        class: {
                          "c-button--primary c-button--border-blue-medium":
                            _vm.variant === "page"
                        },
                        attrs: { href: _vm.link }
                      },
                      [
                        _c("span", { staticClass: "c-button--right" }, [
                          _vm._v(_vm._s(_vm.linkText))
                        ]),
                        _vm._v(" "),
                        _c("v-icon", {
                          attrs: { name: "icon-arrow", size: "xxs" }
                        })
                      ],
                      1
                    )
                  ])
                : _c("p", { staticClass: "c-contact__link" }, [
                    _c("a", { attrs: { href: _vm.link } }, [
                      _vm._v(_vm._s(_vm.linkText))
                    ])
                  ])
            ])
          ]
        : [
            _c("div", { staticClass: "c-contact__wrapper" }, [
              _c("div", { staticClass: "c-contact__heading-and-text" }, [
                _c("p", { staticClass: "c-contact__heading" }, [
                  _vm._v(_vm._s(_vm.heading))
                ]),
                _vm._v(" "),
                _vm.method === "adress"
                  ? _c("dt", { staticClass: "c-contact__text" }, [
                      _c("p", [_vm._v("MKB Fastighets AB")]),
                      _vm._v(" "),
                      _c("p", [_vm._v("Södra Förstadsgatan 47")]),
                      _vm._v(" "),
                      _c("p", [_vm._v("Box 504 05")]),
                      _vm._v(" "),
                      _c("p", [_vm._v("202 14 Malmö")])
                    ])
                  : _c("p", { staticClass: "c-contact__text" }, [
                      _vm._v(_vm._s(_vm.text))
                    ])
              ]),
              _vm._v(" "),
              _vm.method === "chat"
                ? _c("p", { staticClass: "c-contact__link" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "c-button c-button--noboxshadow c-button--icon",
                        class: {
                          "c-button--primary c-button--border-blue-medium":
                            _vm.variant === "page"
                        },
                        attrs: { href: _vm.link }
                      },
                      [
                        _c("span", { staticClass: "c-button--right" }, [
                          _vm._v(_vm._s(_vm.linkText))
                        ]),
                        _vm._v(" "),
                        _c("v-icon", {
                          attrs: { name: "icon-arrow", size: "xxs" }
                        })
                      ],
                      1
                    )
                  ])
                : _vm.link
                ? _c("p", { staticClass: "c-contact__link" }, [
                    _c(
                      "a",
                      {
                        staticClass: "c-contact--action",
                        attrs: { href: _vm.link }
                      },
                      [_vm._v(_vm._s(_vm.linkText))]
                    )
                  ])
                : _vm._e()
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }